// ============================================================
// HABIT OS — Bibliothek: Health
// Supplemente · Hydration · Blood Flow & Gefäße
// ============================================================

export const LIBRARY_HEALTH = {
  id: "health",
  label: "Health",
  icon: "🧬",
  subcategories: [

    // ── SUPPLEMENTE ──────────────────────────
    {
      id: "health_supplements",
      label: "Supplemente",
      icon: "💊",
      habits: [
        {
          id: "hab_vit_d3",
          label: "Vitamin D3 + K2",
          time: "morning",
          icon: "☀️",
          why: "Vitamin D trägt zur Erhaltung normaler Knochen und einer normalen Funktion des Immunsystems bei.",
          source: "Holick MF, New England Journal of Medicine, 2007 · Huberman Lab, Episode 50",
          dose: "Laut Herstellerangabe zu einer fetthaltigen Mahlzeit. Mehr als 20 µg (800 IE) täglich nur nach Bluttest und ärztlicher Rücksprache.",
        },
        {
          id: "hab_magnesium",
          label: "Magnesium L-Threonat",
          time: "night",
          icon: "🌙",
          why: "Magnesium trägt zu einer normalen Funktion des Nervensystems und der Muskeln bei.",
          source: "Slutsky et al., Neuron, 2010 · Huberman Lab, Sleep Toolkit Episode",
          dose: "Laut Herstellerangabe am Abend.",
        },
        {
          id: "hab_creatine",
          label: "Creatin Monohydrat",
          time: "morning",
          icon: "💧",
          why: "Creatin ist eines der am besten erforschten Supplemente der Sportwissenschaft. Kreatin erhöht die körperliche Leistung bei kurzzeitigen intensiven Belastungen (ab 3 g täglich).",
          source: "Rawson & Venezia, JISSN, 2011 · Candow et al., Nutrients, 2023",
          dose: "Laut Herstellerangabe täglich, Timing ist egal — Konsistenz zählt",
        },
        {
          id: "hab_omega3",
          label: "Omega-3 (EPA/DHA)",
          time: "morning",
          icon: "🐟",
          why: "DHA trägt zur Erhaltung einer normalen Gehirnfunktion und Sehkraft bei (ab 250 mg täglich).",
          source: "Attia P., Outlive, 2023 · REDUCE-IT Trial, NEJM, 2018",
          dose: "Laut Herstellerangabe zu einer Mahlzeit.",
        },
        {
          id: "hab_curcumin",
          label: "Kurkumin + Piperin",
          time: "morning",
          icon: "🌿",
          why: "Kurkumin ist der gelbe Farbstoff der Kurkumawurzel. Bei hochdosierten Präparaten wurden seltene Leberschäden gemeldet.",
          source: "Shoba et al., Planta Medica, 1998 · Hewlings & Kalman, Foods, 2017",
          dose: "Laut Herstellerangabe. Bei Lebererkrankungen, Gallensteinen oder Gerinnungshemmern vorher ärztlich abklären.",
        },
        {
          id: "hab_apigenin",
          label: "Apigenin",
          time: "night",
          icon: "🌼",
          why: "Apigenin ist ein Pflanzenstoff, der u. a. in Kamille vorkommt. Die Datenlage beim Menschen ist begrenzt.",
          source: "Viola et al., Planta Medica, 1995 · Huberman Lab, Sleep Toolkit Episode",
          dose: "Alternativ eine Tasse Kamillentee am Abend.",
        },
        {
          id: "hab_lions_mane",
          label: "Lion's Mane",
          time: "morning",
          icon: "🍄",
          why: "Igelstachelbart (Lion's Mane) ist ein Speisepilz aus der asiatischen Küche. Die Studienlage beim Menschen ist klein und vorläufig.",
          source: "Mori et al., Phytotherapy Research, 2009 · Saitsu et al., Biomedical Research, 2019",
          dose: "Laut Herstellerangabe, morgens",
        },
        {
          id: "hab_ashwagandha",
          label: "Ashwagandha (KSM-66)",
          time: "night",
          icon: "🌱",
          why: "Ashwagandha ist eine traditionelle ayurvedische Pflanze. Wegen möglicher Leber- und Schilddrüseneffekte vorher ärztlich abklären; in Schwangerschaft und Stillzeit meiden.",
          source: "Chandrasekhar et al., Indian Journal of Psychological Medicine, 2012 · Langade et al., Cureus, 2019",
          dose: "Nur laut Herstellerangabe und nach ärztlicher Rücksprache.",
        },
        {
          id: "hab_zinc",
          label: "Zink + Kupfer",
          time: "night",
          icon: "🔩",
          why: "Zink trägt zu einer normalen Funktion des Immunsystems sowie zur Erhaltung normaler Haut bei.",
          source: "Prasad AS, Advances in Nutrition, 2013 · Rondanelli et al., Journal of the American Geriatrics Society, 2011",
          dose: "Laut Herstellerangabe zu einer Mahlzeit.",
        },
      ],
    },

    // ── HYDRATION ────────────────────────────
    {
      id: "health_hydration",
      label: "Hydration",
      icon: "💧",
      habits: [
        {
          id: "hab_water_morning",
          label: "500 ml Wasser direkt nach dem Aufwachen",
          time: "morning",
          icon: "🥤",
          why: "Nach 7–8 Stunden ohne Flüssigkeitszufuhr ist der Körper in einem leichten Dehydrations-Zustand. Schon 1–2% Dehydration reduzieren kognitive Leistung messbar. Das morgendliche Trinken aktiviert den Magen-Darm-Trakt und fördert die Peristaltik. Es ist der einfachste 'Biohack' mit sofortigem Effekt.",
          source: "Popkin et al., Nutrition Reviews, 2010 · Huberman Lab, Episode 30",
          dose: "400–500 ml stilles Wasser, idealerweise mit einer Prise Meersalz für Elektrolyte",
        },
        {
          id: "hab_electrolytes",
          label: "Elektrolyte morgens",
          time: "morning",
          icon: "⚡",
          why: "Natrium, Kalium und Magnesium sind an Nerven- und Muskelfunktion beteiligt. Wer viel schwitzt, verliert mehr Elektrolyte.",
          source: "Huberman Lab, Foundational Fitness Protocol · DiNicolantonio & O'Keefe, Open Heart, 2017",
          dose: "Laut Herstellerangabe. Bei Bluthochdruck, Herz- oder Nierenerkrankungen vorher ärztlich abklären.",
        },
        {
          id: "hab_daily_water",
          label: "Tägliches Wasser-Ziel (Körpergewicht × 35 ml)",
          time: "flexible",
          icon: "🫙",
          why: "Die verbreitete '8 Gläser täglich'-Regel ist nicht evidenzbasiert. Die individuelle Empfehlung ist Körpergewicht in kg × 35 ml. Bei 80 kg also 2,8 Liter täglich. Sport, Hitze und Koffein erhöhen den Bedarf. Helles Urin = gut hydriert, dunkles Urin = mehr trinken.",
          source: "Sawka et al., Medicine & Science in Sports & Exercise, 2007",
          dose: "Körpergewicht (kg) × 35 ml = tägliches Minimum, bei Sport +500–1000 ml",
        },
        {
          id: "hab_no_coffee_first",
          label: "90 Min. kein Kaffee nach dem Aufwachen",
          time: "morning",
          icon: "☕",
          why: "Manche Menschen empfinden Kaffee etwas später am Morgen als angenehmer.",
          source: "Huberman Lab, Episode 1 · Porkka-Heiskanen et al., Science, 1997",
          dose: "Mindestens 90 Min. nach dem Aufwachen warten, dann Kaffee oder Espresso",
        },
      ],
    },

    // ── BLOOD FLOW & GEFÄßE ──────────────────
    {
      id: "health_bloodflow",
      label: "Blood Flow & Gefäße",
      icon: "🫀",
      habits: [
        {
          id: "hab_beetroot",
          label: "Rote Bete / Beetroot-Shot",
          time: "morning",
          icon: "🫐",
          why: "Rote Bete ist reich an Nitrat. Wer Blutdruckmedikamente nimmt, sollte größere Mengen vorher ärztlich abklären.",
          source: "Lundberg et al., Nature Reviews Drug Discovery, 2008 · Cermak et al., International Journal of Sport Nutrition, 2012",
          dose: "70–140 ml konzentrierter Beetroot-Shot morgens, 2–3 Stunden vor dem Training",
        },
        {
          id: "hab_sauna",
          label: "Sauna-Protokoll",
          time: "flexible",
          icon: "🧖",
          why: "Saunabaden ist eine traditionelle Wärmeanwendung, die als entspannend empfunden wird. Beobachtungsstudien zeigen Zusammenhänge mit Herzgesundheit, belegen aber keine Ursache-Wirkung.",
          source: "Laukkanen et al., JAMA Internal Medicine, 2015 · Patrick & Johnson, Medical Hypotheses, 2021",
          dose: "2–3 Gänge à 8–15 Min. mit Abkühlpausen, ausreichend trinken. Bei Herz-Kreislauf-Erkrankungen oder niedrigem Blutdruck vorher ärztlich abklären.",
        },
        {
          id: "hab_pomegranate",
          label: "Granatapfel-Extrakt",
          time: "morning",
          icon: "🍎",
          why: "Granatapfel enthält Polyphenole, die Darmbakterien zu Urolithinen umbauen können. Die Forschung dazu ist noch jung.",
          source: "Figueira et al., Nutrients, 2022 · Andreux et al., Nature Metabolism, 2019",
          dose: "Granatapfel-Extrakt laut Herstellerangabe.",
        },
        {
          id: "hab_coq10",
          label: "CoQ10 / Ubiquinol",
          time: "morning",
          icon: "⚡",
          why: "Coenzym Q10 ist an der Energiegewinnung in den Zellen beteiligt. Wer Statine oder andere Medikamente nimmt, sollte eine Einnahme vorher ärztlich abklären.",
          source: "Littarru & Tiano, Biofactors, 2010 · Mortensen et al., JACC: Heart Failure, 2014",
          dose: "Laut Herstellerangabe zu einer fetthaltigen Mahlzeit.",
        },
      ],
    },
  ],
};